import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import { PasswordStrength } from '../auth/PasswordStrength/PasswordStrength';
import clsx from 'clsx';

import './ConfirmPasswordInput.scss';

interface IConfirmPasswordInputProps {
	formik: any;
	fieldName: string;
	placeholder: string;
	showPassword?: boolean;
	setShowPassword?: (value: boolean) => void;
	isPasswordShown?: boolean;
	isPasswordStrengthShown?: boolean;
	additionalClass?: string;
	label?: string;
	required?: boolean;
	isSmallInput?: boolean;
	type?: string;
	// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	autoComplete: string;
}

export const ConfirmPasswordInput = (props: IConfirmPasswordInputProps): JSX.Element => {
	const {
		formik,
		placeholder,
		showPassword,
		setShowPassword,
		fieldName,
		isPasswordShown,
		isPasswordStrengthShown,
		additionalClass,
		label,
		required,
		isSmallInput,
		type,
		autoComplete,
	} = props;

	const fieldLabel = required
		? (
			<>
				<span>{label + ' '}</span>
				<span className="text-danger">*</span>
			</>
		)
		: <span>{label}</span>;

	const getType = (): string => {
		if (type) {
			return type;
		} else {
			return showPassword ? 'text' : 'password';
		}
	};

	return (
		<div className={clsx('field-container', additionalClass)}>
			<label className="form-label col-12">
				{label && fieldLabel}
				<div className="password-container position-relative ">


					<input
						placeholder={placeholder}
						type={getType()}
						{...formik.getFieldProps(fieldName)}
						className={clsx(
							'form-control form-control-solid password-field',
							isSmallInput ? 'form-control-sm' : 'form-control-lg',
							label && 'mt-1'
						)}
						autoComplete={autoComplete}
					/>


					{
						isPasswordShown && (

							<img
								src={toAbsoluteUrl(showPassword ? '/media/icons/eye.svg' : '/media/icons/eye-slash.svg')}
								alt=""
								height="22"
								width="22"
								className="password-eye-icon"
								onClick={(): void => setShowPassword(!showPassword)}
							/>

						)
					}
				</div>
			</label>
			{/*{*/}
			{/*	isPasswordShown && (*/}
			{/*		<div*/}
			{/*			className="eye-container btn btn-hover-danger d-flex align-items-center justify-content-center position-absolute"*/}
			{/*			onClick={(): void => setShowPassword(!showPassword)}*/}
			{/*		>*/}
			{/*			<img*/}
			{/*				src={toAbsoluteUrl(showPassword ? '/media/icons/eye.svg' : '/media/icons/eye-slash.svg')}*/}
			{/*				alt=""*/}
			{/*				height="22"*/}
			{/*				width="22"*/}
			{/*			/>*/}
			{/*		</div>*/}
			{/*	)*/}
			{/*}*/}
			{isPasswordStrengthShown && <PasswordStrength password={formik.values[fieldName]} />}

			<div className={clsx('error-container', isPasswordStrengthShown && 'password-error-container')}>
				{formik.touched[fieldName] && formik.errors[fieldName] && (

					<span className="text-danger fs-8">{formik.errors[fieldName]}</span>

				)}
			</div>
		</div>
	);
};
